import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export { default as Switch } from './Switch.vue'

export const switchVariants = cva(
  'peer inline-flex shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 ',
  {
    variants: {
      size: {
        xs: 'h-4 w-8',
        sm: 'h-5 w-9',
        md: 'h-6 w-11',
        lg: 'h-7 w-14',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  },
)

export const switchThumbVariants = cva(
  'pointer-events-none block rounded-full bg-background shadow-lg ring-0 transition-transform',
  {
    variants: {
      size: {
        xs: 'h-3 w-3 item-checked_translate-x-4',
        sm: 'h-4 w-4 item-checked_translate-x-4',
        md: 'h-5 w-5 item-checked_translate-x-5',
        lg: 'h-6 w-6 item-checked_translate-x-7',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  },
)

export type SwitchVariants = VariantProps<typeof switchVariants>
